// extracted by mini-css-extract-plugin
export var buttonContainer = "_40-6";
export var centeredToolbar = "_40-4";
export var dashdraw = "_40-c";
export var emptyStateContainer = "_40-8";
export var emptyStateText = "_40-9";
export var flowEditor = "_40-0";
export var flowEditorContainer = "_40-7";
export var hovered = "_40-1";
export var leftPanel = "_40-3";
export var mainCanvasContainer = "_40-a";
export var minimap = "_40-b";
export var selectMode = "_40-2";
export var toolbarSeparator = "_40-5";